import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const CommuteCar = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M30 19C30 16.569 28.256 14.539 25.954 14.092C25.498 9.554 21.656 6 17 6C8.729 6 2 11.832 2 19C2 21.597 3.99 23.737 6.525 23.977C7.214 25.184 8.513 26 10 26C11.477 26 12.769 25.194 13.462 24H20.538C21.231 25.194 22.523 26 24 26C25.82 26 27.36 24.777 27.842 23.11C29.145 22.207 30 20.702 30 19ZM23.927 14H16V8.032C16.33 8.011 16.664 8 17 8C20.52 8 23.441 10.612 23.927 14ZM14 8.296V14H5.422C7.136 11.17 10.258 9.047 14 8.296ZM10 24C8.897 24 8 23.103 8 22C8 20.897 8.897 20 10 20C11.103 20 12 20.897 12 22C12 23.103 11.103 24 10 24ZM24 24C22.897 24 22 23.103 22 22C22 20.897 22.897 20 24 20C25.103 20 26 20.897 26 22C26 23.103 25.103 24 24 24ZM27.659 20.386C27.037 18.982 25.632 18 24 18C21.794 18 20 19.794 20 22H14C14 19.794 12.206 18 10 18C7.852 18 6.094 19.703 6.004 21.829C4.838 21.417 4 20.305 4 19C4 17.96 4.171 16.954 4.491 16H25C26.654 16 28 17.346 28 19C28 19.5 27.876 19.971 27.659 20.386Z" />
	</svg>
);

export default CommuteCar;
